export default {
	getSidebarOpenState(state) {
		return state.sidebarIsOpen
	},
}
